import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: '시스템설정',
    icon: 'basicInfo',
    class: 'font-bold',
    url: '/setting/basic'
  },
  {
    name: '공지・문의',
    icon: 'noticeQa',
    class: 'font-bold'
  },
  {
    name: '공지사항',
    url: '/communication/notice',
    class: 'menu-padding-left'
  },
  {
    name: '문의/상담',
    url: '/communication/qna',
    class: 'menu-padding-left'
  },
  {
    name: '운동시설정보',
    icon: 'centerInfo',
    class: 'font-bold'
  },
  {
    name: '등록현황',
    url: '/communication/information',
    class: 'menu-padding-left'
  },
  {
    name: '캐시&N적립금',
    icon: 'cashNpoint',
    class: 'font-bold'
  },
  {
    name: '캐시 관리',
    url: '/setting/cash',
    class: 'menu-padding-left'
  },
  {
    name: 'N적립금 관리',
    url: '/setting/points',
    class: 'menu-padding-left'
  },
  {
    name: '회원관리', 
    icon: 'memberManage',
    class: 'font-bold'
  },
  {
    name: '리스트',
    url: '/member/list',
    class: 'menu-padding-left'
  },
  {
    name: '스마일패스 정산',
    icon: 'smpBalance',
    class: 'font-bold'
  },
  {
    name: '추천코드 정산',
    url: '/setting/codeuser',
    class: 'menu-padding-left'
  },

  {
    name: '메세지관리',
    icon: 'messageManage',
    class: 'font-bold'
  },
  {
    name: '메세지 보내기',
    url: '/member/message/0',
    class: 'menu-padding-left'
  },
  {
    name: '메세지 리스트',
    url: '/member/messagelist',
    class: 'menu-padding-left'
  },
  {
    name: '쿠폰관리',
    icon: 'couponManage',
    class: 'font-bold'
  },
  {
    name: '쇼핑쿠폰 발행',
    url: '/member/coupon',
    class: 'menu-padding-left'
  },
  {
    name: '쿠폰발급 리스트',
    url: '/member/couponlist',
    class: 'menu-padding-left'
  },
  {
    name: '파트너시스템 사용가이드',
    url: '/etc/guide',
    // icon: 'icon-layers',
    class: 'bgColor1',
    // variant: 'success',
    // attributes: { target: '_blank', rel: 'noopener' }
  },
  {
    name: 'SD네트웍스',
    url: 'https://www.sdnetworks.kr',
    // icon: 'icon-cloud-download',
    class: 'bgColor2',
    // variant: 'danger',
    attributes: { target: '_blank', rel: 'noopener' }
  }
];
